export const ROOT = '/';
export const LOGIN_PATTERN = '/login';
export const RESET_PASSWORD_REQUEST = '/reset-password-request';
export const RESET_PASSWORD = '/reset-password';
export const SET_PASSWORD = '/first-password';
export const SETUP_MFA = '/setup-mfa';
export const VERIFY_MFA = '/verify-mfa';
export const OAUTH_CALLBACK = '/oauth/callback/:provider';
export const SESSIONS = '/sessions';
